import { atom, useAtom } from 'jotai';

export const useGrassDonationModalAtom = atom(false);

export function useGrassDonationModal() {
  const [open, setOpen] = useAtom(useGrassDonationModalAtom);

  return {
    value: open,
    open: () => setOpen(true),
    close: () => setOpen(false),
  };
}
